module.exports = __webpack_public_path__ + "img/logo-ct.6216e3d4.png";